function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var html2canvas = require('html2canvas');
var PokerQueue = /*#__PURE__*/function () {
  function PokerQueue() {
    _classCallCheck(this, PokerQueue);
  }
  return _createClass(PokerQueue, [{
    key: "initializeQueue",
    value: function initializeQueue() {
      this.game.queue = [];
      this.game.queue.push('ante');
      this.game.queue.push('READY');
      this.game.queue.push('POOL\t1');
      this.game.queue.push("SIMPLEDEAL\t2\t1\t" + JSON.stringify(this.returnDeck()));
    }
  }, {
    key: "startRound",
    value: function startRound() {
      this.updateLog('===============');
      this.updateLog('Round: ' + this.game.state.round);
      this.updateLog('===============');
      console.log(JSON.parse(JSON.stringify(this.game.state)));
      for (var i = 0; i < this.game.players.length; i++) {
        this.updateLog("Player ".concat(i + 1).concat(i + 1 == this.game.state.button_player ? ' (dealer)' : '', ": ").concat(this.game.state.player_names[i], " (").concat(this.formatWager(this.game.state.player_credit[i], true), ")"));
      }
      this.displayButton();
      this.initializeQueue();
    }

    /**
     *
     * Poker Queue Commands:
     *    winner, newround, resolve, checkplayers,
     *    turn, announce, reveal, ante, round,
     *    call, fold, allin, check, raise, settle
     */
  }, {
    key: "handleGameLoop",
    value: function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        var qe, mv, i, last_mv, alive_players, winner, am_i_out, _i, removal, _i2, player_to_go, active_players, player_left_idx, _i3, winnings, _i4, total_pot, logMsg, winners, _iterator, _step, p, _i5, msg, first_scorer, _i6, cards_to_flip, scorer, card1, card2, _i7, next_scorer, _i8, _winners, winner_keys, updateHTML, winlist, key, deck, score, winlist_length, place, k, w, topPlayer, winning_hand, _p, pot_total, _i9, pot_size, winnerStr, winObj, _logMsg, _i0, wchips, _i1, temp_pot, j, _remainder, _j, _i10, remainder, ii, _i11, share_of_winnings, clearBoardAndContinue, bbpi, sbpi, lastToBet, _i12, _player_to_go, player, amount_to_call, _player, _player2, _player3, raise, call_portion, raise_portion, raise_message, winner_array, method, _i13, voluntary_bet;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.game.queue.length > 0)) {
                _context3.n = 28;
                break;
              }
              this.displayPlayers(true); //to update chips before game_over
              qe = this.game.queue.length - 1;
              mv = this.game.queue[qe].split('\t');
              if (this.browser_active) {
                this.pot.render();
              }
              if (!(mv[0] === 'winner')) {
                _context3.n = 1;
                break;
              }
              this.game.queue = [];
              //this.game.crypto = null;
              this.settleDebt();
              this.sendGameOverTransaction(this.game.players[parseInt(mv[1])], 'elimination');
              return _context3.a(2, 0);
            case 1:
              if (!(mv[0] === 'newround')) {
                _context3.n = 2;
                break;
              }
              this.game.state.round++;

              //Shift dealer, small blind, and big blind
              this.game.state.button_player--; //dealer
              if (this.game.state.button_player < 1) {
                this.game.state.button_player = this.game.players.length;
              }
              if (this.game.players.length > 2) {
                this.game.state.small_blind_player = this.game.state.button_player - 1;
                if (this.game.state.small_blind_player < 1) {
                  this.game.state.small_blind_player = this.game.players.length;
                }
              } else {
                this.game.state.small_blind_player = this.game.state.button_player;
              }
              this.game.state.big_blind_player = this.game.state.small_blind_player - 1;
              if (this.game.state.big_blind_player < 1) {
                this.game.state.big_blind_player = this.game.players.length;
              }

              // This needs to be reset between rounds, hahaah
              // Otherwise, you could fold and still win
              this.game.state.player_cards = {};
              this.game.state.player_cards_reported = 0;
              this.game.state.player_cards_required = 0;
              this.game.state.last_fold = null;
              this.game.state.winners = [];

              //Adjust blind levels if necessary
              if (this.game.blind_mode == 'increase' && this.game.state.round % 5 == 0) {
                //TODO: parameterize num_rounds between increases
                this.game.state.small_blind++;
                this.game.state.big_blind += 2;
                this.updateLog("Blinds increased to: ".concat(this.game.state.big_blind, "/").concat(this.game.state.small_blind));
                salert("Blinds increased to: ".concat(this.game.state.big_blind, "/").concat(this.game.state.small_blind));
              }
              this.updateStatus("".concat(this.game.state.player_names[this.game.state.button_player - 1], " dealing the cards..."));
              this.game.state.flipped = 0;
              this.game.state.plays_since_last_raise = 0;
              this.game.state.last_raise = this.game.state.big_blind;
              this.game.state.required_pot = this.game.state.big_blind;
              this.game.state.all_in = false; //we are stupidly testing for all_in on the display players

              for (i = 0; i < this.game.players.length; i++) {
                this.game.state.passed[i] = 0;
                this.game.state.player_pot[i] = 0;
                this.game.stats[this.game.players[i]].hands++;
              }
              this.pot.activate();
              this.stats.update();
              this.startRound();
              this.syncPlayerJoins();
              return _context3.a(2, 1);
            case 2:
              if (!(mv[0] === 'resolve')) {
                _context3.n = 4;
                break;
              }
              if (!(qe > 0)) {
                _context3.n = 3;
                break;
              }
              last_mv = this.game.queue[qe - 1].split('\t');
              if (!(mv[1] === last_mv[0])) {
                _context3.n = 3;
                break;
              }
              this.game.queue.splice(qe - 1, 2);
              return _context3.a(2, 1);
            case 3:
              console.error('Unexpected resolve in queue, removing and continuing...');
              this.game.queue.splice(qe, 1);
              return _context3.a(2, 1);
            case 4:
              if (!(mv[0] === 'checkplayers')) {
                _context3.n = 7;
                break;
              }
              this.game.queue.splice(qe, 1);
              if (this.gameBrowserActive()) {
                $('.folded').removeClass('folded');
              }

              //Check for end of game -- everyone except 1 player has zero credit...
              alive_players = 0;
              winner = -1;
              am_i_out = false;
              for (_i = 0; _i < this.game.state.player_credit.length; _i++) {
                if (this.game.state.player_credit[_i] > 0) {
                  alive_players++;
                  winner = _i;
                }
              }

              //Catch that only one player is standing at the start of the new round
              if (!(alive_players + this.toJoin.length == 1)) {
                _context3.n = 5;
                break;
              }
              this.game.queue = [];
              this.game.queue.push('winner\t' + winner);
              return _context3.a(2, 1);
            case 5:
              //
              // only remove if there are more than two players
              // if two players - let victory play out.
              //
              removal = false;
              if (alive_players < this.game.state.player_credit.length) {
                for (_i2 = this.game.state.player_credit.length - 1; _i2 >= 0; _i2--) {
                  if (this.game.state.player_credit[_i2] <= 0) {
                    this.updateLog("Player ".concat(_i2 + 1, " (").concat(this.game.state.player_names[_i2], ") has been eliminated from the game."));
                    removal = true;
                    //
                    // remove any players who are missing
                    //
                    if (this.game.players[_i2] == this.publicKey) {
                      am_i_out = true;
                    }
                    this.removePlayer(this.game.players[_i2]);

                    //Adjust dealer for each removed player
                    if (_i2 < this.game.state.button_player) {
                      this.game.state.button_player--;
                      if (this.game.state.button_player < 1) {
                        this.game.state.button_player = this.game.players.length;
                      }
                    }
                  }
                }
              }
              if (!removal) {
                _context3.n = 6;
                break;
              }
              this.halted = 1;
              if (am_i_out) {
                this.updateStatusForPlayerOut('You have been eliminated!', true);
              } else {
                this.resetGameWithFewerPlayers();
              }
              return _context3.a(2, 0);
            case 6:
              return _context3.a(2, 1);
            case 7:
              if (!(mv[0] === 'turn')) {
                _context3.n = 14;
                break;
              }
              player_to_go = parseInt(mv[1]);
              this.game.target = player_to_go;
              //
              // if everyone except 1 player has folded...
              //
              active_players = 0;
              player_left_idx = 0;
              for (_i3 = 0; _i3 < this.game.state.passed.length; _i3++) {
                if (this.game.state.passed[_i3] == 0) {
                  active_players++;
                  player_left_idx = _i3;
                }
              }

              /***********************/
              /*PLAYER WINS HAND HERE*/
              /***********************/
              if (!(active_players === 1)) {
                _context3.n = 8;
                break;
              }
              winnings = 0;
              for (_i4 = 0; _i4 < this.game.state.player_pot.length; _i4++) {
                if (_i4 !== player_left_idx) {
                  winnings += this.game.state.player_pot[_i4];

                  // Track who wins how many chips from whom
                  this.game.state.chip_exchange[_i4][player_left_idx] -= this.game.state.player_pot[_i4];
                  this.game.state.chip_exchange[player_left_idx][_i4] += this.game.state.player_pot[_i4];
                }
              }
              total_pot = winnings + this.game.state.player_pot[player_left_idx];
              logMsg = "".concat(this.game.state.player_names[player_left_idx], " wins ").concat(this.formatWager(winnings));
              this.updateLog(logMsg);

              // For animating
              winners = {};
              winners[player_left_idx] = this.game.state.player_credit[player_left_idx];
              this.game.state.player_credit[player_left_idx] += total_pot;
              this.game.stats[this.game.players[player_left_idx]].wins++;

              // Poker Stats
              if (this.game.state.flipped == 0) {
                if (total_pot == this.game.state.big_blind + this.game.state.small_blind) {
                  // No one called or raised --> walk
                  _iterator = _createForOfIteratorHelper(this.game.players);
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      p = _step.value;
                      this.game.stats[p].walks++;
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }
              }

              //So that userline updates with winner
              this.game.state.winners = [player_left_idx + 1];
              this.displayPlayers();

              //
              // everyone settles with winner if needed
              //
              if (this.game.crypto) {
                for (_i5 = 0; _i5 < this.game.players.length; _i5++) {
                  if (_i5 != player_left_idx) {
                    //
                    // only losers
                    //
                    if (this.game.state.player_pot[_i5] > 0) {
                      this.game.state.debt[_i5] += this.game.state.player_pot[_i5];
                      this.game.state.debt[player_left_idx] -= this.game.state.player_pot[_i5];
                    }
                  }
                }
              }

              // if everyone has folded - start a new round
              msg = "".concat(this.game.state.player_names[player_left_idx], " wins the round");
              if (this.game.player == player_left_idx + 1) {
                msg = 'You win the round';
              } else {
                this.cardfan.hide();
              }
              this.playerbox.setActive(player_left_idx + 1);
              this.animateWin(total_pot, winners);
              this.halted = 1;
              this.game.queue.push("settle\t".concat(JSON.stringify([this.game.players[player_left_idx]]), "\tfold"));
              this.playerAcknowledgeNotice(msg, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _this.updateStatus("Clearing the table".concat(_this.needToSettleDebt() ? ' and settling bets' : '', "..."));
                      _this.animating = false;
                      _this.cardfan.hide();
                      _this.pot.clearPot();
                      _this.board.clearTable();
                      _this.clearPlayers();
                      _context.n = 1;
                      return _this.timeout(1000);
                    case 1:
                      _this.restartQueue();
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              })));
              this.saveGame(this.game.id);
              this.setShotClock('.acknowledge', 5000, false);
              return _context3.a(2, 0);
            case 8:
              if (!(this.game.state.plays_since_last_raise >= this.game.players.length)) {
                _context3.n = 10;
                break;
              }
              if (!(this.game.state.flipped == 5)) {
                _context3.n = 9;
                break;
              }
              this.playerbox.setInactive();
              console.log('PREPARE FOR SHOWDOWN');
              this.game.queue = [];
              first_scorer = 0;
              for (_i6 = 1; _i6 <= this.game.state.passed.length; _i6++) {
                if (this.game.state.passed[_i6 - 1] == 0) {
                  first_scorer = first_scorer || _i6;
                  this.game.state.player_cards_required++;
                  this.game.state.player_cards[_i6] = [];
                  this.game.stats[this.game.players[_i6 - 1]].showdowns++;
                }
              }
              if (first_scorer == this.game.player) {
                this.addMove("reveal\t".concat(this.game.player, "\t").concat(this.game.deck[0].hand[0], "\t").concat(this.game.deck[0].hand[1]));
                this.endTurn();
              }
              return _context3.a(2, 0);
            case 9:
              cards_to_flip = this.game.state.flipped == 0 ? 3 : 1;
              this.game.state.flipped += cards_to_flip;

              //We can't just push "announce", have to reset queue to clear out any remaining turns
              this.game.queue = ['round', 'announce'];
              this.game.queue.push("POOLDEAL\t1\t".concat(cards_to_flip, "\t1"));
              this.game.state.plays_since_last_raise = 0;
              return _context3.a(2, 1);
            case 10:
              if (!(this.game.state.passed[player_to_go - 1] == 1)) {
                _context3.n = 11;
                break;
              }
              //
              // we auto-clear without need for player to broadcast
              //
              this.game.state.plays_since_last_raise++;
              this.game.queue.splice(qe, 1);
              return _context3.a(2, 1);
            case 11:
              if (!(this.game.state.player_credit[player_to_go - 1] == 0)) {
                _context3.n = 12;
                break;
              }
              //
              // we auto-clear without need for player to broadcast
              //
              this.game.state.plays_since_last_raise++;
              this.game.queue.splice(qe, 1);
              return _context3.a(2, 1);
            case 12:
              this.playerbox.setActive(player_to_go);
              if (player_to_go == this.game.player) {
                this.playerTurn();
              } else {
                this.displayPlayerNotice("<div class=\"plog-update\">thinking</div>", player_to_go);
                if (this.game.state.passed[this.game.player - 1]) {
                  //this.updateStatus('waiting for next round');
                } else {
                  //this.updateStatus('waiting for ' + this.game.state.player_names[player_to_go - 1]);
                }
              }
            case 13:
              return _context3.a(2, 0);
            case 14:
              if (!(mv[0] === 'announce')) {
                _context3.n = 16;
                break;
              }
              this.game.queue.splice(qe, 1);
              this.board.render(true);
              this.displayPlayers(true);
              if (!(this.game.state.flipped === 0)) {
                _context3.n = 15;
                break;
              }
              if (this.game.player > 0) {
                this.updateLog('** HOLE CARDS **');
                this.updateLog("[".concat(this.cardToHuman(this.game.deck[0].hand[0]), " ").concat(this.cardToHuman(this.game.deck[0].hand[1]), "]"));
              }
              return _context3.a(2, 1);
            case 15:
              if (this.game.state.flipped === 3) {
                this.updateLog('*** FLOP ***');
                this.updateLog("[".concat(this.cardToHuman(this.game.pool[0].hand[0]), " ").concat(this.cardToHuman(this.game.pool[0].hand[1]), " ").concat(this.cardToHuman(this.game.pool[0].hand[2]), "]"));
              }
              if (this.game.state.flipped === 4) {
                this.updateLog('**** TURN ****');
                this.updateLog("[".concat(this.cardToHuman(this.game.pool[0].hand[0]), " ").concat(this.cardToHuman(this.game.pool[0].hand[1]), " ").concat(this.cardToHuman(this.game.pool[0].hand[2]), "] [").concat(this.cardToHuman(this.game.pool[0].hand[3]), "]"));
              }
              if (this.game.state.flipped === 5) {
                this.updateLog('***** RIVER *****');
                this.updateLog("[".concat(this.cardToHuman(this.game.pool[0].hand[0]), " ").concat(this.cardToHuman(this.game.pool[0].hand[1]), " ").concat(this.cardToHuman(this.game.pool[0].hand[2]), "] [").concat(this.cardToHuman(this.game.pool[0].hand[3]), "] [").concat(this.cardToHuman(this.game.pool[0].hand[4]), "]"));
              }
              return _context3.a(2, 1);
            case 16:
              if (!(mv[0] === 'reveal')) {
                _context3.n = 21;
                break;
              }
              scorer = parseInt(mv[1]);
              card1 = mv[2];
              card2 = mv[3];
              this.game.queue.splice(qe, 1);

              //Pocket
              this.game.state.player_cards[scorer].push(this.returnCardFromDeck(card1));
              this.game.state.player_cards[scorer].push(this.returnCardFromDeck(card2));
              if (scorer != this.game.player) {
                this.showPlayerHand(scorer, card1, card2);
                this.updateLog("* HOLE CARDS -- ".concat(this.game.state.player_names[scorer - 1], " *"));
                this.updateLog("[".concat(this.cardToHuman(card1), " ").concat(this.cardToHuman(card2), "]"));
              }

              //Everyone can use the pool
              for (_i7 = 0; _i7 < 5; _i7++) {
                this.game.state.player_cards[scorer].push(this.returnCardFromDeck(this.game.pool[0].hand[_i7]));
              }
              this.game.state.player_cards_reported++;
              if (!(this.game.state.player_cards_reported !== this.game.state.player_cards_required)) {
                _context3.n = 20;
                break;
              }
              //If not everyone has reported there hand yet, find the next in sequence from this scorer
              next_scorer = 0;
              _i8 = scorer;
            case 17:
              if (!(_i8 < this.game.state.passed.length)) {
                _context3.n = 19;
                break;
              }
              if (!(this.game.state.passed[_i8] == 0)) {
                _context3.n = 18;
                break;
              }
              next_scorer = _i8 + 1;
              return _context3.a(3, 19);
            case 18:
              _i8++;
              _context3.n = 17;
              break;
            case 19:
              if (this.game.player == next_scorer) {
                this.addMove("reveal\t".concat(this.game.player, "\t").concat(this.game.deck[0].hand[0], "\t").concat(this.game.deck[0].hand[1]));
                this.endTurn();
              }
              return _context3.a(2, 0);
            case 20:
              //
              // we have all of the hands, and can pick a winner
              //
              this.displayPlayers();

              // PLAYER WINS HAND HERE
              //
              _winners = [];
              winner_keys = [];
              updateHTML = '';
              winlist = []; //Sort hands from low to high
              for (key in this.game.state.player_cards) {
                deck = this.game.state.player_cards[key];
                if (winlist.length == 0) {
                  winlist.splice(0, 0, {
                    player: parseInt(key),
                    player_hand: this.scoreHand(deck)
                  });
                } else {
                  score = this.scoreHand(deck);
                  winlist_length = winlist.length;
                  place = 0;
                  for (k = 0; k < winlist_length; k++) {
                    w = this.pickWinner(winlist[k].player_hand, score);
                    if (w > 1) {
                      place = k + 1;
                    }
                  }
                  winlist.splice(place, 0, {
                    player: parseInt(key),
                    player_hand: score
                  });
                }
              }

              // Populate winners with winning players
              topPlayer = winlist[winlist.length - 1];
              winning_hand = topPlayer.player_hand.hand_description;
              console.log('Showdown:', winlist);

              // ... and anyone else who ties
              this.playerbox.setInactive();
              for (_p = 0; _p < winlist.length; _p++) {
                if (this.pickWinner(topPlayer.player_hand, winlist[_p].player_hand) == 3) {
                  _winners.push(winlist[_p].player - 1);
                  winner_keys.push(this.game.players[winlist[_p].player - 1]);
                  this.playerbox.setActive(winlist[_p].player, false);
                }
              }

              // Put my key first, if it is in the list
              _winners.sort(function (a, b) {
                if (b == _this.game.player - 1) {
                  return 1;
                }
                return 0;
              });
              pot_total = 0;
              for (_i9 = 0; _i9 < this.game.state.player_pot.length; _i9++) {
                pot_total += this.game.state.player_pot[_i9];
              }
              // split winnings among winners
              pot_size = Math.floor(pot_total / _winners.length);
              winnerStr = '';
              winObj = {}; // single winner gets everything
              _logMsg = " split the pot for ".concat(this.formatWager(pot_size), " each");
              if (_winners.length == 1) {
                _logMsg = _winners[0] == this.game.player - 1 ? ' win' : ' wins';
                _logMsg += " ".concat(this.formatWager(pot_total), " (").concat(this.formatWager(pot_total - this.game.state.player_pot[_winners[0]], false), " net)");
                for (_i0 = 0; _i0 < this.game.state.player_pot.length; _i0++) {
                  // Track who wins how many chips from whom
                  if (_i0 !== _winners[0]) {
                    this.game.state.chip_exchange[_i0][_winners[0]] -= this.game.state.player_pot[_i0];
                    this.game.state.chip_exchange[_winners[0]][_i0] += this.game.state.player_pot[_i0];
                  }
                }
              } else {
                //
                // It is very complicated when splitting a pot...
                //
                wchips = new Array(_winners.length).fill(0);
                for (_i1 = 0; _i1 < this.game.state.player_pot.length; _i1++) {
                  if (!_winners.includes(_i1)) {
                    temp_pot = Math.floor(this.game.state.player_pot[_i1] / _winners.length);
                    for (j = 0; j < _winners.length; j++) {
                      // Track who wins how many chips from whom
                      wchips[j] += temp_pot;
                      this.game.state.chip_exchange[_i1][_winners[j]] -= temp_pot;
                      this.game.state.chip_exchange[_winners[j]][_i1] += temp_pot;
                    }
                    _remainder = this.game.state.player_pot[_i1] - temp_pot * _winners.length;
                    if (_remainder) {
                      for (_j = 0; _j < _winners.length && _remainder > 0; _j++) {
                        if (wchips[_j] < pot_size) {
                          _remainder--;
                          wchips[_j]++;
                          this.game.state.chip_exchange[_i1][_winners[_j]]--;
                          this.game.state.chip_exchange[_winners[_j]][_i1]++;
                        }
                      }
                    }
                  }
                }
              }
              for (_i10 = 0; _i10 < _winners.length; _i10++) {
                if (_i10 >= 1) {
                  if (_i10 + 1 < _winners.length) {
                    winnerStr += ', ';
                  } else {
                    winnerStr += ', and ';
                  }
                }

                // For animating chip change
                winObj[_winners[_i10]] = this.game.state.player_credit[_winners[_i10]];
                this.game.stats[this.game.players[_winners[_i10]]].wins++;
                if (_winners[_i10] == this.game.player - 1) {
                  winnerStr += 'You';
                } else {
                  winnerStr += this.game.state.player_names[_winners[_i10]];
                }
                this.game.state.player_credit[_winners[_i10]] += pot_size;
                this.game.state.winners.push(_winners[_i10] + 1);
              }
              remainder = pot_total - pot_size * _winners.length;
              if (remainder > 0) {
                this.updateLog("The pot doesn't divide evenly among the winners, leaving ".concat(remainder, " for the house"));
              }
              this.displayPlayers();
              _logMsg = winnerStr + _logMsg;

              // update splash!
              if (_winners.length == 1) {
                if (_winners[0] == this.game.player - 1) {
                  winnerStr += " win with ".concat(winning_hand.toUpperCase(), "!");
                } else {
                  winnerStr += " wins with ".concat(winning_hand.toUpperCase(), "!");
                }
              } else {
                winnerStr += " split the pot with ".concat(winning_hand.toUpperCase(), "!");
              }
              winlist.forEach(function (pl) {
                _this.updateLog("".concat(_this.game.state.player_names[pl.player - 1], ": ").concat(pl.player_hand.hand_description, " <br> ").concat(_this.toHuman(pl.player_hand.cards_to_score)));
                var player_hand = _this.game.state.player_cards[pl.player].slice(0, 2);
                updateHTML = "<div class=\"player-result\">" + _this.handToHTML(pl.player_hand.cards_to_score, player_hand) + '</div>' + updateHTML;
                updateHTML = "<div class=\"h3\">".concat(_this.game.state.player_names[pl.player - 1], ": ").concat(pl.player_hand.hand_description, "</div>").concat(updateHTML);
              });

              //update log
              this.updateLog(_logMsg);
              this.updateHTML = updateHTML;

              //
              // non-winners send wagers to winner
              //
              if (this.game.crypto !== 'CHIPS') {
                for (ii = 0; ii < this.game.players.length; ii++) {
                  for (_i11 = 0; _i11 < _winners.length; _i11++) {
                    if (!_winners.includes(ii) && this.game.state.player_pot[ii] > 0) {
                      share_of_winnings = this.game.state.player_pot[ii] / _winners.length;
                      this.game.state.debt[ii] += share_of_winnings;
                      this.game.state.debt[_winners[_i11]] -= share_of_winnings;
                    }
                  }
                }
              }
              this.animateWin(pot_total, winObj);
              this.halted = 1;
              this.updateStatus(winnerStr);
              this.saveGame(this.game.id);
              clearBoardAndContinue = function clearBoardAndContinue() {
                var screenshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                _this.game.queue.push("settle\t".concat(JSON.stringify(winner_keys), "\tbesthand"));
                _this.playerAcknowledgeNotice(winnerStr, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _this.updateStatus("Clearing the table".concat(_this.needToSettleDebt() ? ' and settling bets' : '', "..."));
                        console.log('Continuing poker...');
                        _this.animating = false;
                        _this.cardfan.hide();
                        _this.pot.clearPot();
                        _this.board.clearTable();
                        _this.clearPlayers();
                        _context2.n = 1;
                        return _this.timeout(800);
                      case 1:
                        _this.restartQueue();
                      case 2:
                        return _context2.a(2);
                    }
                  }, _callee2);
                })));
                _this.setShotClock('.acknowledge', 9000, false, function () {
                  _this.game_help.render({
                    title: 'Showdown',
                    text: "Tip: click anywhere on the screen to interrupt the 3 second countdown that keeps the game moving along",
                    //img: '/poker/img/poker_screenshot.jpg',
                    line1: 'what',
                    line2: 'happened?',
                    fontsize: '2.1rem',
                    id: 'showdown',
                    callback: function callback() {
                      if (screenshot) {
                        var ov = document.querySelector('.game-help-overlay');
                        if (ov) {
                          ov.prepend(screenshot);
                        }
                      }
                    }
                  });
                });
              };
              if (this.game.player) {
                html2canvas(document.body, {
                  /*scale: 0.8,
                             	width: 0.8*window.innerWidth,
                             	height: 0.8*window.innerHeight,*/
                  ignoreElements: function ignoreElements(element) {
                    if (element.classList.contains('cardBack')) {
                      return true;
                    }
                    if (element.classList.contains('pot')) {
                      return true;
                    }
                    if (element.classList.contains('poker-player-stake')) {
                      return true;
                    }
                    if (element.id === 'log-wrapper') {
                      return true;
                    }
                    if (element.id === 'saito-header') {
                      return true;
                    }
                  }
                }).then(clearBoardAndContinue);
              } else {
                clearBoardAndContinue();
              }
              return _context3.a(2, 0);
            case 21:
              //Set up bets for beginning of round (new deal)
              if (mv[0] == 'ante') {
                this.game.queue.splice(qe, 1);
                this.board.render(true);
                bbpi = this.game.state.big_blind_player - 1; //
                // Big Blind
                //
                if (this.game.state.player_credit[bbpi] <= this.game.state.big_blind) {
                  this.updateLog(this.game.state.player_names[bbpi] + " posts remaining ".concat(this.game.state.player_credit[bbpi], " chips for big blind and is removed from game"));
                  //Put all the player tokens in the pot and have them pass / remove
                  this.game.state.player_pot[bbpi] += this.game.state.player_credit[bbpi];
                  this.game.state.player_credit[bbpi] = 0;
                  this.game.state.passed[bbpi] = 1;
                } else {
                  this.updateLog("".concat(this.game.state.player_names[bbpi], " posts big blind: ").concat(this.formatWager(this.game.state.big_blind)));
                  this.game.state.player_pot[bbpi] += this.game.state.big_blind;
                  this.game.state.player_credit[bbpi] -= this.game.state.big_blind;
                }

                //
                // Small Blind
                //
                sbpi = this.game.state.small_blind_player - 1;
                if (this.game.state.player_credit[sbpi] <= this.game.state.small_blind) {
                  this.updateLog(this.game.state.player_names[sbpi] + " posts remaining ".concat(this.game.state.player_credit[sbpi], " chips as small blind and is removed from the game"));
                  this.game.state.player_pot[sbpi] += this.game.state.player_credit[sbpi];
                  this.game.state.player_credit[sbpi] = 0;
                  this.game.state.passed[sbpi] = 1;
                } else {
                  this.updateLog("".concat(this.game.state.player_names[sbpi], " posts small blind: ").concat(this.formatWager(this.game.state.small_blind)));
                  this.game.state.player_pot[sbpi] += this.game.state.small_blind;
                  this.game.state.player_credit[sbpi] -= this.game.state.small_blind;
                }

                /*if (!this.loadGamePreference('poker-hide-pot')) {
                	let html = `<div class="poker-player-stake"><span class="stake-in-chips">${this.game.state.player_pot[bbpi]}</span></div>`;
                	this.playerbox.replaceGraphics(html, '.poker-player-stake', bbpi + 1);
                	html = `<div class="poker-player-stake"><span class="stake-in-chips">${this.game.state.player_pot[sbpi]}</span></div>`;
                	this.playerbox.replaceGraphics(html, '.poker-player-stake', sbpi + 1);
                }*/

                this.game.queue.push('round'); //Start
                this.game.queue.push('announce'); //Print Hole cards to Log
              }

              /* Set up a round
              		       We don't splice it, so we keep coming back here after each player has taken their turn
              		       until we reach an endgame state which runs startNextRound and clears to queue
              	        */
              if (mv[0] === 'round') {
                // Start betting to the left of the big blind on first turn
                lastToBet = this.game.state.flipped == 0 && this.game.state.plays_since_last_raise < this.game.players.length ? this.game.state.big_blind_player : this.game.state.button_player;
                for (_i12 = lastToBet; _i12 <= lastToBet + this.game.players.length - 1; _i12++) {
                  _player_to_go = _i12 % this.game.players.length;
                  if (_player_to_go == 0) {
                    _player_to_go = this.game.players.length;
                  }
                  this.game.queue.push('turn\t' + _player_to_go);
                }
              }
              if (!(mv[0] === 'call')) {
                _context3.n = 23;
                break;
              }
              player = parseInt(mv[1]);
              amount_to_call = this.game.state.required_pot - this.game.state.player_pot[player - 1];
              if (amount_to_call <= 0) {
                console.error("Zero/Negative Call -- Player ".concat(player));
                console.debug('Game state: ', JSON.parse(JSON.stringify(this.game.state)));
              }
              if (this.game.state.player_credit[player - 1] === amount_to_call) {
                this.game.state.all_in = true;
                this.updateLog(this.game.state.player_names[player - 1] + ' goes all in to call');
                if (this.game.player !== player) {
                  this.displayPlayerNotice("<div class=\"plog-update\">all in!</div>", player);
                } else {
                  this.updateStatus('all in!');
                }
              } else {
                this.updateLog(this.game.state.player_names[player - 1] + ' calls to match ' + this.formatWager(this.game.state.required_pot));
                if (this.game.player !== player) {
                  this.displayPlayerNotice("<div class=\"plog-update\">calls</div>", player);
                } else {
                  this.updateStatus('you called');
                }
              }
              this.game.state.plays_since_last_raise++;
              _context3.n = 22;
              return this.animateBet(player, amount_to_call);
            case 22:
              this.game.state.player_pot[player - 1] += amount_to_call;
              this.game.state.player_credit[player - 1] -= amount_to_call;
              this.game.queue.splice(qe, 1);
              return _context3.a(2, 1);
            case 23:
              if (mv[0] === 'fold') {
                _player = parseInt(mv[1]);
                this.updateLog(this.game.state.player_names[_player - 1] + " folds with ".concat(this.formatWager(this.game.state.player_pot[_player - 1])));
                this.game.stats[this.game.players[_player - 1]].folds++;
                this.game.state.passed[_player - 1] = 1;
                this.game.state.last_fold = _player;
                this.game.queue.splice(qe, 1);
                this.game.state.plays_since_last_raise++;
                if (this.browser_active) {
                  if (this.game.player !== _player) {
                    this.displayPlayerNotice("<div class=\"plog-update\">folds</div>", _player);
                    this.playerbox.addClass('folded', _player);
                  } else {
                    this.updateStatus('you folded');
                    this.displayHand();
                    this.ignore_notifications = true;
                  }
                }
              }
              if (!(mv[0] === 'allin')) {
                _context3.n = 24;
                break;
              }
              this.game.queue.splice(qe, 1);
              this.game.state.plays_since_last_raise++;
              return _context3.a(2, 1);
            case 24:
              if (!(mv[0] === 'check')) {
                _context3.n = 25;
                break;
              }
              _player2 = parseInt(mv[1]);
              this.game.queue.splice(qe, 1);
              this.updateLog(this.game.state.player_names[_player2 - 1] + ' checks.');
              if (this.game.player !== _player2 && this.browser_active) {
                this.displayPlayerNotice("<div class=\"plog-update\">checks</div>", _player2);
              } else {
                this.updateStatus('you checked');
              }
              this.game.state.plays_since_last_raise++;

              /*let qs = this.playerbox.replaceGraphics(`<div class="poker-player-stake"><span class="stake-in-chips">${this.game.state.player_pot[player - 1]}</span></div>`, ".poker-player-stake", player); 
                    if (this.loadGamePreference("poker-hide-pot")){
                        setTimeout(()=> {
                          document.querySelector(qs).classList.add("invisible");
                        }, 500);
                    }*/
              return _context3.a(2, 1);
            case 25:
              if (!(mv[0] === 'raise')) {
                _context3.n = 27;
                break;
              }
              _player3 = parseInt(mv[1]);
              raise = parseInt(mv[2]);
              call_portion = this.game.state.required_pot - this.game.state.player_pot[_player3 - 1];
              raise_portion = raise - call_portion;
              this.game.state.plays_since_last_raise = 1;

              // Update message before animation...
              raise_message = "bets ".concat(this.formatWager(raise_portion));
              if (this.game.state.player_credit[_player3 - 1] == raise) {
                this.game.state.all_in = true;
                raise_message = "goes all in";
              }
              if (this.game.player !== _player3) {
                this.displayPlayerNotice("<div class=\"plog-update\">".concat(raise_message, "</div>"), _player3);
              } else {
                this.updateStatus(raise_message);
              }
              _context3.n = 26;
              return this.animateBet(_player3, raise);
            case 26:
              this.game.state.player_credit[_player3 - 1] -= raise;
              this.game.state.player_pot[_player3 - 1] += raise;
              this.game.state.last_raise = raise_portion;
              this.game.state.required_pot += raise_portion;
              raise_message += " to ".concat(this.formatWager(this.game.state.player_pot[_player3 - 1]));
              if (call_portion > 0) {
                if (raise_portion > 0) {
                  this.updateLog("".concat(this.game.state.player_names[_player3 - 1], " calls and ").concat(raise_message));
                } else {
                  // This condition shouldn't exist... no raise is just a call (a different queue command)
                  this.updateLog("".concat(this.game.state.player_names[_player3 - 1], " calls ").concat(this.formatWager(call_portion)));
                }
              } else {
                this.updateLog("".concat(this.game.state.player_names[_player3 - 1], " ").concat(raise_message));
              }
              this.game.queue.splice(qe, 1);
              return _context3.a(2, 1);
            case 27:
              if (mv[0] === 'settle') {
                winner_array = JSON.parse(mv[1]);
                method = mv[2];
                /*
                                We want these at the end of the queue so they get processed first, but if
                                any players got removed, there will be some issues....
                            */
                this.game.queue.push('newround');
                this.game.queue.push('PLAYERS');
                this.game.queue.push('checkplayers');
                if (this.needToSettleDebt()) {
                  this.settleDebt();
                }
                this.settleNow = false;

                //
                // We will calculate vpip here, before resetting the next round
                // If a player voluntarily added money to the pot, +1
                // >>>>>>>>>>
                for (_i13 = 1; _i13 <= this.game.players.length; _i13++) {
                  voluntary_bet = this.game.state.player_pot[_i13 - 1];
                  this.game.state.player_pot[_i13 - 1] = 0;
                  if (_i13 == this.game.state.small_blind_player) {
                    voluntary_bet -= this.game.state.small_blind;
                  }
                  if (_i13 == this.game.state.big_blind_player) {
                    voluntary_bet -= this.game.state.big_blind;
                  }
                  if (voluntary_bet > 0) {
                    this.game.stats[this.game.players[_i13 - 1]].vpip++;
                  }
                }
                this.game.queue.push("ROUNDOVER\t".concat(JSON.stringify(winner_array), "\t").concat(method));
              }
            case 28:
              return _context3.a(2, 1);
          }
        }, _callee3, this);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }()
  }]);
}();
module.exports = PokerQueue;